<ag-shr-modal-window
  #modalRef
  [title]="'Update Invitee Outcome Status'"
  [width]="500"
  [height]="'auto'"
  [inProgress]="inProgress$ | async"
  [useScrollView]="false"
  (onSaveClick)="handleSave()"
>
  @if (modalRef?.popupComponent?.visible ?? false) {
    <div class="update-invitee-outcome-status-modal__content">
      <p class="pb-2" [ngPlural]="attendeesCount">
        <ng-template ngPluralCase="=1">
          {{ attendeesCount }} invitee has no outcome status.<br />
        </ng-template>
        <ng-template ngPluralCase="other">
          {{ attendeesCount }} invitees have no outcome status.<br />
        </ng-template>
        Choose the outcome that should be applied for them:
      </p>

      <dx-select-box
        [dataSource]="inviteeOutcomeStatusLookup"
        displayExpr="description"
        valueExpr="value"
        [(value)]="selectedOutcomeStatus"
        stylingMode="outlined"
        [width]="'100%'"
      >
        <dx-validator>
          <dxi-validation-rule type="required" [message]="Messages.REQUIRED_TEXT"></dxi-validation-rule>
        </dx-validator>
      </dx-select-box>
    </div>
  }
</ag-shr-modal-window>
